import { formatInt, formatTokens, getEntryPointColor, getEntryPointLabel } from "./formatters";

type EntryPointRow = { source: string; responses: number; totalTokens: number };

export function EntryPointStackedBar({ data }: { data: EntryPointRow[] }) {
  const totalAllTokens = data.reduce((sum, r) => sum + r.totalTokens, 0);
  const totalResponses = data.reduce((sum, r) => sum + r.responses, 0);

  if (totalAllTokens === 0) return null;

  return (
    <div className="space-y-2">
      {/* Stacked bar */}
      <div className="bg-cyber-bg/80 flex h-5 overflow-hidden rounded-full">
        {data.map((row) => {
          const pct = (row.totalTokens / totalAllTokens) * 100;
          if (pct < 0.5) return null;
          return (
            <div
              key={row.source}
              className="h-full transition-all duration-300 first:rounded-l-full last:rounded-r-full"
              style={{
                width: `${pct}%`,
                backgroundColor: getEntryPointColor(row.source).bar,
                opacity: 0.75,
              }}
              title={`${getEntryPointLabel(row.source)}: ${formatTokens(row.totalTokens)} tokens (${Math.round(pct)}%)`}
            />
          );
        })}
      </div>

      {/* Legend */}
      <div className="flex flex-wrap gap-x-4 gap-y-1">
        {data.map((row) => {
          const pct = totalResponses > 0 ? Math.round((row.responses / totalResponses) * 100) : 0;
          return (
            <div key={row.source} className="flex items-center gap-1.5 text-[11px]">
              <div
                className="h-2 w-2 flex-shrink-0 rounded-full"
                style={{ backgroundColor: getEntryPointColor(row.source).bar }}
              />
              <span className="text-cyber-text tracking-wide uppercase">
                {getEntryPointLabel(row.source)}
              </span>
              <span className="text-cyber-muted">
                {formatInt(row.responses)} ({pct}%)
              </span>
              <span className="text-cyber-muted">&middot;</span>
              <span className={getEntryPointColor(row.source).label}>
                {formatTokens(row.totalTokens)}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
